import React from 'react';
import * as Styled from './styled';
import { useLocale } from 'locale';

interface ITermsLineProps {
  small?: boolean;
}

export const TermsLine: React.FC<ITermsLineProps> = ({ small = true }) => {
  const { t } = useLocale();

  return (
    <Styled.Root className="terms-line">
      <Styled.Label small={small}>{t('contactForm.contact.hint.start')}</Styled.Label>
      <Styled.LinkLabel small={small} href="/etc/terms" target="_blank">{t('contactForm.contact.hint.link')}</Styled.LinkLabel>
      <Styled.Label small={small}>{t('contactForm.contact.hint.end')}</Styled.Label>
    </Styled.Root>
  );
};
